module.exports = __webpack_public_path__ + "static/SignageLight-743f3966da05547269afdc38b7fd5dc6.png";